import './polyfills';

import VueRouter from 'vue-router';
import { setDomainUrl } from "./api";
import CourseItem from "./components/CourseItem.vue";

export default {
    install(Vue, { baseUrl } = {}) {
        Vue.use(VueRouter);
        if(baseUrl) {
            setDomainUrl(baseUrl);
        }
        Vue.prototype.$cursus = {
            baseUrl,
        }
        Vue.component('cursus-course-item', CourseItem);
    }
}
